import React from "react";
import { FinancialDocumentSelect } from "@components/documents/FinancialDocumentSelect/FinancialDocumentSelect";
import { DocumentSelectVariant } from "@components/documents/FinancialDocumentSelect/financialDocumentSelectViewConfig";
import { useFinancialDocumentFilters } from "@components/documents/useFinancialDocumentFilters";
import { DocumentCta } from "@components/documents/FinancialDocumentList/DocumentCta";

interface Props {
    attachedDocumentIds: number[];
    attachDocument: (documentId: number) => void;
    attachDocuments?: (documentIds: number[]) => void;
    variant?: DocumentSelectVariant;
    initialFilters?: Parameters<typeof useFinancialDocumentFilters>[1];
}

export const DocumentSelect: React.FC<Props> = ({
    attachedDocumentIds,
    attachDocument,
    attachDocuments,
    variant = DocumentSelectVariant.DOCUMENT_ATTACHMENT,
    initialFilters,
}) => (
    <FinancialDocumentSelect
        variant={variant}
        attachedDocumentIds={attachedDocumentIds}
        attachDocuments={attachDocuments}
        initialFilters={initialFilters}
        cta={(financialDocument) => (
            <DocumentCta
                attachedDocumentIds={attachedDocumentIds}
                attachDocument={attachDocument}
                financialDocument={financialDocument}
            />
        )}
    />
);
